// ============================================================
// systems/effects.js — Visual particle / sparkle / ring effects
// ============================================================
import { state } from '../state.js';

/**
 * Spawn a simple floating "+N" text particle near (x, y).
 */
export function spawnParticle(x, y) {
  const p = document.createElement('div');
  p.className = 'particle';
  p.textContent = '+' + state.clickPower;
  p.style.left = (x + (Math.random() - 0.5) * 40) + 'px';
  p.style.top = (y - 10) + 'px';
  document.body.appendChild(p);
  setTimeout(() => p.remove(), 700);
}

/**
 * Spawn a ring-burst effect at (x, y). (kept as no-op for compatibility)
 */
export function spawnRingBurst() {}

/**
 * Spawn a background sparkle (skipped during phase 3 for performance).
 */
export function spawnSparkle() {
  if (state.phase3Active) return;
  const s = document.createElement('div');
  s.className = 'sparkle';
  const size = Math.random() * 6 + 3;
  s.style.width = size + 'px';
  s.style.height = size + 'px';
  s.style.left = Math.random() * 100 + 'vw';
  s.style.background = `hsl(${Math.random() * 50 + 30}, 100%, 75%)`;
  s.style.animationDuration = (Math.random() * 4 + 4) + 's';
  s.style.animationDelay = (Math.random() * 3) + 's';
  document.body.appendChild(s);
  setTimeout(() => s.remove(), 9000);
}
